import React from "react";
import { Layout } from "antd";

const { Footer } = Layout;

const HFooter = () => {
  return (
    <Footer style={{ textAlign: "center" }}>
      Galaxy Education ©2021
    </Footer>
  );
};

export default HFooter;
